import React from 'react'
import logoImg from './video_logo.png'

const Logo = () => {
  return (
    <div className="flex items-center space-x-2 text-xl md:text-2xl font-bold select-none shrink-0">
      {/* Constrained logo image so it doesn't overflow or clip */}
      <img 
        src={logoImg} 
        alt="Logo" 
        className="h-9 md:h-11 w-auto object-contain pointer-events-none"
      />
      <span className="text-white drop-shadow-[0_1px_2px_rgba(0,0,0,0.8)]">
        Videos
      </span>
    </div>
  )
}

export default Logo
